export default {
  en: {
    agentInformation: 'Information',
    name: 'Name',
    type: 'Type',
    market: 'Market',
    address: 'Address',
    country: 'Country',
    zipCode: 'Zip Code',
    email: 'Email',
    tel: 'Tel',
    fax: 'Fax',
    internalNote: 'Internal Note',
    edit: 'Edit Information'
  },
  th: {
    agentInformation: 'ข้อมูลตัวแทน',
    name: 'ชื่อ',
    type: 'ประเภท',
    market: 'ตลาด',
    address: 'ที่อยู่',
    country: 'ประเทศ',
    zipCode: 'รหัสไปรษณีย์',
    email: 'อีเมล',
    tel: 'โทร.',
    fax: 'แฟกซ์',
    internalNote: 'หมายเหตุ',
    edit: 'แก้ไขข้อมูล'
  }
}
